import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";
import { detailsTranslations } from "./translationsDetails";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("malta-adria-lang");
    return saved && translations[saved] ? saved : "en";
  });

  const changeLang = useCallback((code) => {
    if (translations[code]) {
      setLang(code);
      localStorage.setItem("malta-adria-lang", code);
    }
  }, []);

  const t = { ...translations[lang], details: detailsTranslations[lang] };

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
